export const getCustomStyles = (theme: any) => {
  return {
    container: (provided: any) => ({
      ...provided,
      width: '100%',
      cursor: 'pointer',
    }),
    control: (provided: any) => ({
      ...provided,
      cursor: 'pointer',
      border: `1px solid ${theme.COLORS.PrimaryInputBorder}`,
      background: theme.COLORS.PrimaryInputBg,
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: theme.COLORS.textw,
    }),
    menu: (provided: any) => ({
      ...provided,
      border: `1px solid ${theme.COLORS.PrimaryInputBorder}`,
      background: theme.COLORS.PrimaryInputBg,
    }),
    menuList: (provided: any) => ({
      ...provided,
      background: theme.COLORS.PrimaryInputBg,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      background: state.isSelected
        ? theme.COLORS.PrimaryInputBorder
        : state.isFocused
          ? theme.COLORS.PrimaryInputBorder + '80'
          : theme.COLORS.PrimaryInputBg,
      color: theme.COLORS.textw,
      cursor: 'pointer',
      '&:active': {
        background: theme.COLORS.PrimaryInputBorder,
      },
    }),
  };
};
